import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BasicDropDown } from '@components-clean/core/basic-dropdown';
import { IsPopOut } from '@components-clean/core/page-toolbar/page-toolbar';
import { StudySelectorListItem, StudySelectorItem } from '@components-clean/navbar/study-selector-item';
import { useTranslation } from '@hooks/index';
import './study-selector.scss';

interface StudySelectorProps {
    disabled?: boolean;
    isOrgUser: boolean;
    hideBorder: boolean;
    studies: StudySelectorItem[];
    selectedStudy: StudySelectorItem | null;
    loadingStudies: boolean;
    selectStudy: (study: StudySelectorItem) => void;
}

const StudySelector = ({
    disabled,
    isOrgUser,
    hideBorder,
    studies,
    selectedStudy,
    loadingStudies,
    selectStudy,
}: StudySelectorProps) => {
    const { t } = useTranslation();
    const orgUserWithNoStudies = !loadingStudies && isOrgUser && studies.length === 0;

    return (
        <div
            className="k-d-flex k-align-items-center k-w-full study-selector"
            style={{
                columnGap: '10px',
                maxWidth: '250px',
            }}
        >
            <FontAwesomeIcon icon={['far', 'screen-users']} size="xl" className="k-color-white" />
            <BasicDropDown
                className="k-h-8 k-w-full navbar-dropdown"
                tooltipClassName="study-dropdown-tooltip"
                data={studies}
                value={selectedStudy}
                loading={loadingStudies}
                disabled={orgUserWithNoStudies || disabled}
                readOnly={IsPopOut()}
                textField="studyNumber"
                dataItemKey="id"
                onChange={(e) => {
                    const selected = e.value as StudySelectorItem;
                    selectStudy(selected);
                }}
                data-testid="select-study-in-focus"
                itemRender={(li, itemProps) => (
                    <StudySelectorListItem li={li} dataItem={itemProps.dataItem as StudySelectorItem} />
                )}
                hideBorder={hideBorder}
                customClassName="navbar-popup"
                tooltipText={orgUserWithNoStudies ? t('home:userNoStudies') : undefined}
                filterable
            />
        </div>
    );
};

export default StudySelector;
